// Built-in starter email templates. Shown in the Email Builder picker with a "Starter" tag.
// They live in code only: an agent opens one, customizes it, and saves their own copy with the
// normal Save template flow. Listing tokens ({{address}}, {{beds}} ...) can be filled from
// "Fill from a listing" (src/lib/listingLookup.js); anything not found stays as an editable token.
export const LISTING_TOKENS = ['address', 'price', 'beds', 'baths', 'sqft', 'photo_url', 'listing_url', 'date', 'time', 'full_address'];

export const STARTER_EMAIL_TEMPLATES = [
  {
    starterId: 'open-house',
    name: 'Open House Announcement',
    subject: "You're Invited: Open House at {{address}}",
    blocks: [
      { type: 'header', logo: '', bg: '#000000' },
      { type: 'image', style: 'hero', src: '{{photo_url}}', alt: 'Front of {{full_address}}', url: '{{listing_url}}' },
      { type: 'heading', style: 'serif', text: "You're Invited to an Open House" },
      { type: 'text', text: "Hi {{first_name|there}},\n\nI'd love for you to stop by {{address}}. Walk through at your own pace and ask me anything about the home and the community. Everyone is welcome." },
      { type: 'openhouse', date: '{{date}}', time: '{{time}}', where: '{{full_address}}', beds: '{{beds}}', baths: '{{baths}}', sqft: '{{sqft}}', price: '{{price}}', buttonText: 'View details', url: '{{listing_url}}' },
      { type: 'text', text: "Can't make it? Reply to this email and I'll set up a private showing at a time that works for you." },
      { type: 'signature' },
    ],
  },
  {
    starterId: 'just-listed',
    name: 'Just Listed',
    subject: 'Just Listed: {{address}}',
    blocks: [
      { type: 'header', logo: '', bg: '#000000' },
      { type: 'image', style: 'hero', src: '{{photo_url}}', alt: 'Front of {{full_address}}', url: '{{listing_url}}' },
      { type: 'heading', style: 'serif', text: 'Just Listed' },
      { type: 'text', text: "Hi {{first_name|there}},\n\nI'm pleased to share my newest listing at {{address}}. Take a look at the photos and the video tour, and let me know if you'd like to see it in person." },
      { type: 'openhouse', label: 'Just Listed', date: '', time: '', where: '{{full_address}}', beds: '{{beds}}', baths: '{{baths}}', sqft: '{{sqft}}', price: '{{price}}', buttonText: 'View details', url: '{{listing_url}}' },
      { type: 'gallery', cols: '2', photos: ['', '', '', ''] },
      { type: 'video', url: '', caption: 'Take the video tour', thumb: '' },
      { type: 'signature' },
    ],
  },
  {
    starterId: 'agent-open-house',
    name: 'Open House (Agent Outreach)',
    subject: 'Open House for Your Buyer: {{address}}',
    blocks: [
      { type: 'header', logo: '', bg: '#000000' },
      { type: 'image', style: 'hero', src: '{{photo_url}}', alt: 'Front of {{full_address}}', url: '{{listing_url}}' },
      { type: 'heading', style: 'serif', text: 'Open House for Your Buyer' },
      { type: 'text', text: "Hi {{first_name|there}},\n\nThe MLS shows you have a client looking for this type of property, so I wanted to make sure you saw my open house at {{address}}. You and your buyer are welcome to stop by, and I'm happy to answer any questions before you come." },
      { type: 'openhouse', date: '{{date}}', time: '{{time}}', where: '{{full_address}}', beds: '{{beds}}', baths: '{{baths}}', sqft: '{{sqft}}', price: '{{price}}', buttonText: 'View details', url: '{{listing_url}}' },
      { type: 'text', text: "If the open house time doesn't work, call or text me and I'll set up a private showing for you and your client." },
      { type: 'signature' },
    ],
  },
  {
    starterId: 'agent-just-listed',
    name: 'Just Listed (Agent Outreach)',
    subject: 'New Listing for Your Buyer: {{address}}',
    blocks: [
      { type: 'header', logo: '', bg: '#000000' },
      { type: 'image', style: 'hero', src: '{{photo_url}}', alt: 'Front of {{full_address}}', url: '{{listing_url}}' },
      { type: 'heading', style: 'serif', text: 'Just Listed' },
      { type: 'text', text: "Hi {{first_name|there}},\n\nThe MLS shows you have a client looking for this type of property, so I wanted you to be one of the first to know about my new listing at {{address}}. Take a look at the photos and the video tour below." },
      { type: 'openhouse', label: 'Just Listed', date: '', time: '', where: '{{full_address}}', beds: '{{beds}}', baths: '{{baths}}', sqft: '{{sqft}}', price: '{{price}}', buttonText: 'View details', url: '{{listing_url}}' },
      { type: 'gallery', cols: '2', photos: ['', '', '', ''] },
      { type: 'video', url: '', caption: 'Take the video tour', thumb: '' },
      { type: 'text', text: "If it looks like a fit, call or text me and I'll get you and your buyer in to see it. I'm happy to answer any questions." },
      { type: 'signature' },
    ],
  },
];

export const starterById = (id) => STARTER_EMAIL_TEMPLATES.find((t) => t.starterId === id);
// A fresh, unsaved working copy (no id), so "Save template" creates the agent's own template.
export const openStarter = (t) => ({ name: t.name, subject: t.subject, blocks: t.blocks.map((b) => ({ ...b })), starterId: t.starterId });
